<template>
  <div class="sf-container" v-if="invoice">
    <h2>
      Invoice Reference: {{ invoice?.school_reference || invoice?.reference }}
    </h2>
    <SagePay
      :mode="'payinvoice'"
      :invoice-id="invoiceId"
      :purchase-data="invoice.storePurchase.purchaseData"
    />
  </div>
</template>

<script lang="ts">
import SagePay from "@/components/purchase/SagePay.vue";
import apiCall from "@/func/net/apiCall";
import { SfInvoice } from "@/types/generalTypes";
import { defineComponent } from "vue";

export default defineComponent({
  components: { SagePay },
  data() {
    return {
      invoice: null as SfInvoice | null,
    };
  },
  computed: {
    invoiceId() {
      return parseInt(this.$route.params.invoiceId as string);
    },
  },
  mounted() {
    this.refreshInvoice();
  },
  methods: {
    async refreshInvoice() {
      const resData = await apiCall("store-invoice/" + this.invoiceId);
      if (resData.success) {
        this.invoice = resData.data as SfInvoice;
      }
    },
  },
});
</script>
